import { render, staticRenderFns } from "./Source_ofsupply.vue?vue&type=template&id=b6451a3e&scoped=true"
import script from "./Source_ofsupply.vue?vue&type=script&lang=js"
export * from "./Source_ofsupply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6451a3e",
  null
  
)

export default component.exports